import { action, computed, makeObservable, observable } from "mobx";
import { getAgentList } from "../../services";

class AgentListStore {
    agents = [];
    currentAgentId = "";
    isLoading = false;
    error = null;
    requestId = null;
    msgCode = null;

    constructor() {
        makeObservable(this, {
            agents: observable,
            currentAgentId: observable,
            isLoading: observable,
            error: observable,
            requestId: observable,
            msgCode: observable,

            setAgents: action,
            setCurrentAgentId: action,
            setError: action,
            setRequestId: action,
            setMsgCode: action,
            fetchAgentList: action,
            
            
            currentAgent: computed,
            hasAgents: computed,
            agentsCount: computed
        });
    }

   
    setAgents = (agents) => { this.agents = agents; };
    setCurrentAgentId = (agentId) => { this.currentAgentId = agentId; };
    setError = (error) => { this.error = error; };
    setRequestId = (requestId) => { this.requestId = requestId; };
    setMsgCode = (msgCode) => { this.msgCode = msgCode; };

   
    get currentAgent() {
        return this.agents.find(agent => agent.uuid === this.currentAgentId);
    }

    get hasAgents() {
        return this.agents.length > 0;
    }

    get agentsCount() {
        return this.agents.length;
    }

   
    fetchAgentList = async () => {
        try {
            this.isLoading = true;
            this.error = null;
            
            const { data } = await getAgentList();
            
            this.setAgents(data.agents || []);
            this.setRequestId(data.requestId);
            this.setMsgCode(data.msgCode);

        } catch (error) {
            console.error('Error in fetchAgentList:', error);
            this.error = "Error fetching agents list";
            throw error;
        } finally {
            this.isLoading = false;
        }
    };

    
    selectFirstAgent = () => {
        if (this.hasAgents) {
            this.setCurrentAgentId(this.agents[0].uuid);
            return true;
        }
        return false;
    };

    clearSelection = () => {
        this.setCurrentAgentId("");
    };
}

export default AgentListStore;